import * as yup from "yup";

import { Box, Button, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InputNumber from "@/components/hookForms/inputNumber";
import TextInput from "@/components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceRebalanceUsinaHistoricoGeracao from "@/services/serviceRebalanceUsinaHistoricoGeracao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: {
        open: boolean;
        id: number;
        geracaoPrevista: number;
        nomeUsina: string;
        cicloFaturamento: string;
        producaoEspecifica: string;
        observacao?: string;
        risco?: string;
    };
    onClose?: any;
}

export default function DialogEdit({ open, data, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const validationSchema = yup.object().shape({
        geracaoPrevista: yup.string().required(messages.requiredField),
        observacao: yup.string().nullable(),
        risco: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            geracaoPrevista: 0,
            observacao: "",
            risco: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);

        const newValues = {
            rebalanceUsinaHistoricoGeracaoID: values.id,
            geracaoPrevista: values.geracaoPrevista.replace(/\./g, '').replace(',', '.'),
            observacao: values.observacao,
            risco: values.risco,
        };

        serviceRebalanceUsinaHistoricoGeracao
            .update(newValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Editar
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Box>
                        <Typography variant="subtitle1">
                            <b>Usina:</b> {data.nomeUsina}
                        </Typography>
                        <Typography variant="subtitle1">
                            <b>Mês referência:</b> {data.cicloFaturamento}
                        </Typography>
                        <Typography variant="subtitle1">
                            <b>Capacidade:</b> {data.producaoEspecifica}
                        </Typography>
                        <Grid container display="flex" alignItems="center">
                            <Grid item xs={12} md={3}>
                                <Typography variant="subtitle1">
                                    {" "}
                                    <b>Geração</b>
                                </Typography>
                            </Grid>

                            <Grid item xs={12} md={9}>
                                <InputNumber
                                    name="geracaoPrevista"
                                    label="Insira o valor"
                                    control={control}
                                    error={errors}
                                    decimalScale={2}
                                    noThousandSeparator
                                    maxLength={13}
                                />
                            </Grid>
                        </Grid>

                        <Grid container display="flex" alignItems="center" style={{ marginTop: "16px" }}>
                            <Grid item xs={12} md={3}>
                                <Typography variant="subtitle1">
                                    <b>Observação</b>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <TextInput
                                    name="observacao"
                                    label="Insira a observação"
                                    control={control}
                                    error={errors}
                                    multiline
                                    maxLength={500}
                                />
                            </Grid>
                        </Grid>

                        <Grid container display="flex" alignItems="center" style={{ marginTop: "16px" }}>
                            <Grid item xs={12} md={3}>
                                <Typography variant="subtitle1">
                                    <b>Risco</b>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <TextInput
                                    name="risco"
                                    label="Insira o risco"
                                    control={control}
                                    error={errors}
                                    maxLength={200}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
